import { render } from "./WorkshopCard.vue?vue&type=template&id=113898d9&scoped=true"
import script from "./WorkshopCard.vue?vue&type=script&lang=js"
export * from "./WorkshopCard.vue?vue&type=script&lang=js"

import "./WorkshopCard.vue?vue&type=style&index=0&id=113898d9&scoped=true&lang=css"

import exportComponent from "/container/application/releases/20260729235012/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-113898d9"]])

export default __exports__